import { Component } from 'react';

/** Components */
import Keypad from './Keypad';
import LatexKeypadButton from './LatexKeypadButton';
import KeypadButton from './KeypadButton';
import MathModeKey from './MathModeKey';

class Chemistry extends Component {
  render() {
    return (
      <Keypad className="chemistry" {...this.props}>
        <div>
          {/* Symbols */}
          <LatexKeypadButton label="\text{H}^{}" />
          <LatexKeypadButton label="\text{H}_{}" />
          <LatexKeypadButton label="\frac{}{}" />
          <LatexKeypadButton label="_{}^{}" />
          {/* Chemistry */}
          <KeypadButton label="mol" />
          <KeypadButton label="log" />
          {/* Greek Alpha */}
          <LatexKeypadButton label="\Delta" />
        </div>
        <div>
          {}
          <LatexKeypadButton label="({})" />
          <LatexKeypadButton label="[{}]" />
          <LatexKeypadButton label="|{}|" />
          {/** Symbols */}
          <KeypadButton label="&prime;" />
          {/* Greek Alpha */}
          <KeypadButton label="&plusmn;" />
          <LatexKeypadButton label="\leftrightarrow" />
          <LatexKeypadButton label="\delta" />
        </div>
        <div>
          {/* Symbols */}
          <KeypadButton label="&lt;" />
          <KeypadButton label="&gt;" />
          <KeypadButton label="&ge;" />
          <KeypadButton label="&le;" />
          <KeypadButton label="&#8776;" />
          <KeypadButton label="&ne;" />
          <LatexKeypadButton label="\circ" />
        </div>
        <div>
          {/* Logic */}
          <LatexKeypadButton label="\leftarrow" />
          <LatexKeypadButton label="\to" />
          <LatexKeypadButton label="\leftrightarrow" />
          <LatexKeypadButton label="\Rightarrow" />
          {/* Symbols */}
          <LatexKeypadButton label="\sqrt{}" />
          {/* Math Roman */}
          <MathModeKey />
        </div>
      </Keypad>
    );
  }
}

export default Chemistry;
